var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.25,
    stroke: "#29264A",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3376 18.6623L10.0248 14.3495C9.65839 13.9831 9.65839 13.3912 10.0248 13.0247C10.3913 12.6583 10.9832 12.6583 11.3497 13.0247L15.0047 16.6704L18.6503 13.0247C19.0168 12.6583 19.6087 12.6583 19.9752 13.0247C20.3416 13.3912 20.3416 13.9831 19.9752 14.3495L15.6624 18.6623C15.3054 19.0287 14.704 19.0287 14.3376 18.6623Z",
    fill: "#29264A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectboxIcon);
export default __webpack_public_path__ + "static/media/SelectboxIcon.bec77955.svg";
export { ForwardRef as ReactComponent };